module.exports = __webpack_public_path__ + "static/media/bg8.e643a6cf.jpg";